var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon--support",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C7.62386 2 4.05285 5.54525 4.00391 9.91016L2.9043 22H12H15V20H12C8.67444 20 6 17.3256 6 14V13C6 11.8833 6.88333 11 8 11H16C17.1167 11 18 11.8833 18 13V16H13.9121C13.7005 15.4014 13.1349 15.0009 12.5 15C11.6716 15 11 15.6716 11 16.5C11.0011 17.286 11.6086 17.9379 12.3926 17.9941C12.4283 17.998 12.4641 18 12.5 18H19H20C21.1 18 22 17.1 22 16V14C22 12.9 21.1 12 20 12V10C20 5.59356 16.4064 2 12 2H12ZM12 4C15.1725 4 17.7458 6.43568 17.9766 9.54687C17.3903 9.20841 16.721 9 16 9H8C7.27897 9 6.60973 9.20841 6.02344 9.54687C6.25424 6.43568 8.82753 4 12 4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon--support.45f32f6d46584a197702559252309315.svg";
export { ForwardRef as ReactComponent };